import Table from '@/common/components/Table';
import TextField from '@/common/components/TextField';
import { DatePickerWithRange } from '@/common/components/ui/dateRangePicker';
import useDebounce from '@/common/hooks/useDebounce';
import { useFilterParams } from '@/common/hooks/useFilterParams';
import { Mapper } from '@/common/services/mapper';
import { SearchIcon } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { useEquipmentEvents } from '../../../hooks/useEquipmentEvents';
import { UserEventData, UserEventTableItem } from '../../../types/userEvents.type';
import { EquipmentEventsTransformer } from '../../../services/equipmentEventsTransformer';
import { equipmentConsumptionHistoryColumns } from '../../../constants/equipmentConsumptionHistoryColumns.constant';
import { useFilterDate } from '@/common/hooks/useFilterDate';

export const ConsumptionHistory = () => {
  const { id: equipmentId } = useParams();

  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.consumptionHistorySearch || '');

  const { date, formattedDate } = useFilterDate(filterParams);

  const {
    data: equipmentEvents,
    meta,
    isFetching: equipmentEventsIsFetching,
  } = useEquipmentEvents({
    filters: {
      equipmentId,
      search,
      page: filterParams.page || 1,
      startDate: formattedDate.from,
      endDate: formattedDate.to,
    },
    mapper: Mapper.mapWithTransformer<UserEventData[], UserEventTableItem[]>({
      transformer: EquipmentEventsTransformer.tableTransformer(),
    }),
  });

  return (
    <div className="flex flex-col gap-6">
      <TextField
        LeftIcon={<SearchIcon />}
        placeholder="Pesquisar"
        className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
        value={filterParams.consumptionHistorySearch || ''}
        onChange={(e: any) => {
          setSearch(e.target?.value);
          setFilterParams((prev) => ({
            ...prev,
            consumptionHistorySearch: e.target?.value,
          }));
        }}
      />

      <div className="flex">
        <DatePickerWithRange date={date} setDate={(date) => setFilterParams((params) => ({ ...params, date }))} />
      </div>

      <Table
        className="max-h-[calc(100vh-324px)]"
        columns={equipmentConsumptionHistoryColumns}
        isLoadingData={equipmentEventsIsFetching}
        rows={equipmentEvents}
        rowEmptyValue="--"
        page={filterParams.page || 1}
        setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        totalPages={meta.total_pages}
        totalCount={meta.total}
      />
    </div>
  );
};
